<template>
  <div :class="{ calrendarFlex: flexStyle == 'flex' }">
    <Calendar
      @onClickDay="onClickDay"
      @onChangeDate="onChangeDate"
      :courseDate="times"
      :showRightSide="true"
    ></Calendar>
    <div>
      <el-tabs class="courseTab" v-model="activeName" v-if="interactive_course_periods.length">
        <el-tab-pane :label="systemPeriodLabel" name="0">
          <StudyCalendarItem :list="system_course_periods" />
        </el-tab-pane>
        <el-tab-pane
          v-if="interactive_course_periods.length"
          :label="interactivePeriodLable"
          name="1"
        >
          <StudyCalendarItem :list="interactive_course_periods" isInterActive />
        </el-tab-pane>
      </el-tabs>
      <StudyCalendarItem :list="system_course_periods" v-else />

      <!-- <div class="list" v-if="list.length > 0">
        <div v-for="(item, index) in list" :key="index" class="item-list">
          <template v-if="item.course_type != 0">
            <div class="item-card">
              <div class="left">
                <div class="time">
                  {{ new Date(item.start_play * 1000).format('hh:mm') }}-{{
                    new Date(item.end_play * 1000).format('hh:mm')
                  }}
                </div>
                <div class="state-wrap">
                  <span
                    class="state"
                    :class="'state-' + item.live_status"
                    v-if="
                      item.periods_type == 2 || item.periods_type == 3 || item.periods_type == 23
                    "
                  >
                    <span v-if="item.live_status == 0">未开始</span>
                    <span v-else-if="item.live_status == 1" class="living">
                      <span class="primary-color">直播中</span>
                    </span>
                    <span
                      v-else-if="
                        item.live_status == 2 || item.live_status == 3 || item.live_status == 4
                      "
                    >
                      <span>已结束</span>
                    </span>
                  </span>
                  <span
                    v-if="item.course_type == 7"
                    class="state"
                    :class="'state-' + item.live_status"
                  >
                    <span v-if="item.live_status == 0">未开始</span>
                    <span v-else-if="item.live_status == 1">
                      <span class="primary-color">上课中</span>
                    </span>
                    <span
                      v-else-if="
                        item.live_status == 2 || item.live_status == 3 || item.live_status == 4
                      "
                    >
                      <span>已结束</span>
                    </span>
                  </span>
                </div>
              </div>
              <div class="line"></div>
              <div class="main">
                <div class="main-line"></div>
                <div class="main-content">
                  <div @click="showDialog(item)" style="cursor: default">
                    <span class="type">{{ item.course_type_name }}</span>
                    <span class="title">
                      <template v-if="item.type == 1">
                        <span v-if="item.chapter_title" style="margin-right: 12px">
                          {{ item.chapter_title }}
                        </span>
                      </template>
                      <span v-if="item.course_type != 1">
                        {{ item.title }}
                      </span>
                      <span v-else>{{ item.teacher_name }}</span>
                    </span>
                  </div>
                  <div class="subtitle" v-if="item.course_title">
                    {{ item.course_title }}
                  </div>
                  <div class="subtitle" v-else-if="item.oto_desc">
                    {{ item.oto_desc }}
                  </div>
                  <template v-if="item.type == 1 || item.type == 2">
                    <FileList :fileList="item.notes || []" />
                  </template>
                  <template v-if="item.type != 1 && item.type != 2 && item.notes_status == 1">
                    <FileList :fileList="[{ ...item, ware_filename: item.notes_name }]" />
                  </template>
                </div>
                <div class="live-state">
                  <template
                    v-if="
                      item.course_type == 1 ||
                      item.course_type == 2 ||
                      item.course_type == 3 ||
                      item.course_type == 15 ||
                      item.course_type == 16 ||
                      item.course_type == 23
                    "
                  >
                    <span
                      v-if="item.live_status == 0"
                      class="period-living"
                      @click.stop="goToPlay(item)"
                    >
                      立即进入
                    </span>
                    <span
                      v-else-if="item.live_status == 1"
                      class="period-living"
                      @click.stop="goToPlay(item)"
                    >
                      立即进入
                    </span>
                    <template v-else>
                      <template v-if="item.course_type == 16">
                        <span v-if="item.live_status == 3" @click.stop="goToPlay(item, 1)">
                          大班回放
                        </span>
                        <span v-if="item.live_status == 3" @click.stop="goToPlay(item)">
                          小班回放
                        </span>
                      </template>
                      <span v-else-if="item.course_type == 23" @click.stop="goToPlay(item, 1)">
                        课程回放
                      </span>
                      <span v-else-if="item.live_status == 3" @click.stop="goToPlay(item)">
                        查看回放
                      </span>
                      <span class="disabled" v-else :style="{ cursor: 'not-allowed' }">
                        查看回放
                      </span>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </template>
          <template v-if="item.course_type == 0">
            <MeetingCard :item="getMeetingInfo(item)" @goToPlay="goToMeeting" />
          </template>
        </div>
      </div>
      <EmptyNew class="empty" title="暂无内容" v-else /> -->
    </div>
    <!-- <CourseContentTip
      v-if="showContentDialog"
      :show.sync="showContentDialog"
      :content="chapter_content"
    ></CourseContentTip> -->
    <!-- <CourseSoldOutTip v-if="showSoldOut" :show.sync="showSoldOut"></CourseSoldOutTip> -->
    <MemberArrangeItem
      ref="arrange"
      v-show="false"
      :item="currentArrangeItem"
      :type="currentArrangeItem.type == 1 || currentArrangeItem.type == 2 ? 1 : 2"
      @leave="getData"
    ></MemberArrangeItem>
    <LeaveModal
      :show-modal.sync="showModal"
      :onLeaveSubmit="onLeaveSubmit"
      :period="leave.course"
    />
    <!-- <ContactTeacherDialog
      :visible="showContactTeacherDialog"
      :interceptText="currentItem.interception_info?.interceptText.split('_')[0]"
      :wechatWorkQrCode="currentItem.interception_info?.wechat_work_qr_code"
      @close="showContactTeacherDialog = false"
    /> -->
  </div>
</template>
<script>
import Calendar from '@/components/Calendar.vue';
// import CourseSoldOutTip from '@/modules/stu/components/CourseSoldOutTip.vue';
// import MeetingCard from './classes/MeetingCard';
import MemberArrangeItem from '@/modules/stu/views/periods/components/MemberArrangeItem.vue';
import LeaveModal from './classes/LeaveModal';
// import EmptyNew from '@/components/EmptyNew.vue';
// import FileList from '@/modules/stu/components/FileList';
// import CourseContentTip from '@/modules/stu/components/CourseContentTip';
// import ContactTeacherDialog from './ContactTeacherDialog';
import StudyCalendarItem from './StudyCalendarItem';

import * as enums from '@/utils/enums.js';

export default {
  name: 'StudyCalendar',
  props: {
    timesUrl: {
      type: String,
      default: '/api/app/study/schedule',
    },
    dateUrl: {
      type: Function,
    },
    flexStyle: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      activeName: '0',
      times: [],
      PeriodTypeEnum: {
        ALL: 0,
        OTO_CLASS: 1, //一对一 约课
        BIG_CLASS: 2, //大班课
        SMALL_CLASS: 3, //小班课
        PUBLIC_CLASS: 4, //公开课
        VIDEO_CLASS: 5, //点播课
        FACE_CLASS: 7, //面授课
        AUDIO_CLASS: 8, //音频课
        SYSTEM_CLASS: 9, //系统课
        PICTURE_CLASS: 10, // 图文课
        VIP_CLASS: 11, //vip课
        GROUP_CLASS: 15, //分组课课节
        DOUBLE_TEACHER_CLASS: 16, //双师课
        MULTIPLE_CLASS: 22, //混合课
      },
      interactive_course_periods: [],
      system_course_periods: [],
      showModal: false,
      leave: {
        course: {},
      },
      time: 0,
      currentArrangeItem: {},
      hideMore: null,
    };
  },
  components: {
    Calendar,

    MemberArrangeItem,
    // MeetingCard,
    LeaveModal,
    // EmptyNew,
    // FileList,
    // CourseContentTip,
    // ContactTeacherDialog,
    StudyCalendarItem,
  },
  async created() {
    this.getStudySchedule();
    this.time = parseInt(new Date().getTime() / 1000);
    await this.getData();
    this.$emit('load');
  },
  mounted() {
    // 延迟上报
    setTimeout(() => {
      this.$webSeeSendTrack({
        event_id: 'my_study_calendar_show',
      });
    }, 500);
    this.hideMore = () => {
      this.hideAll();
    };
    document.addEventListener('click', this.hideMore);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideMore);
  },
  computed: {
    systemPeriodLabel() {
      return this.system_course_periods.length
        ? `系统课（${this.system_course_periods.length}）`
        : '系统课';
    },
    interactivePeriodLable() {
      return this.interactive_course_periods.length
        ? `互动课（${this.interactive_course_periods.length}）`
        : '互动课';
    },
  },
  methods: {
    async getStudySchedule(date) {
      this.times = await this.$http.get(this.timesUrl, {
        date: (date ? new Date(date) : new Date()).format('yyyy-MM'),
      });
    },
    showDialog(row) {
      if (row.periods_type == 7) {
        this.showContentDialog = true;
        this.chapter_content = row.content;
      }
    },
    getMeetingInfo(item) {
      let live_status;
      if (item.live_status == 0) {
        live_status = 1;
      } else if (item.live_status == 1) {
        live_status = 2;
      } else {
        live_status = 3;
      }
      return {
        ...item,
        start_time: item.start_play,
        end_time: item.end_play,
        live_status: live_status,
      };
    },
    //进入班会  id,type
    goToMeeting(data, type) {
      this.$livePlay(0, 'meeting', {
        id: 0,
        title: data.meeting_name,
        meeting_id: data.id,
        type: type,
      });
    },
    //请假
    onLeave(course) {
      this.leave.course = course;
      this.showModal = true;
    },
    async onLeaveSubmit(leaveInfo) {
      await this.$http.post('/api/app/leave', {
        leave_cause: leaveInfo.content,
        class_id: this.id,
        course_id: this.leave.course.course_basis_id,
        course_periods_id: this.leave.course.periods_id,
        uid: this.$store.state.user_info.id,
      });
      await this.getData();
    },
    async getData() {
      let url;
      if (this.dateUrl) {
        url = this.dateUrl(this.time);
      } else {
        // 废弃/api/app/study/live， 换成/api/app/study/dateCourse/
        // url = '/api/app/study/live/' + this.time;
        url = '/backend-api/app/study/dateCourse/' + this.time;
      }
      let { interactive_course_periods, system_course_periods } = await this.$http.get(url);
      // let ts = parseInt(new Date().getTime() / 1000);
      interactive_course_periods.forEach((item) => {
        item.mixType = item.course_type;
        item.course_type = item.periods_type || item.course_type;
        item.course_type_name = enums.CoursePeriodsType.getValue(item.course_type);
        this.handleSendViewTrack(item);
      });
      system_course_periods.forEach((item) => {
        item.mixType = item.course_type;
        item.course_type = item.periods_type || item.course_type;
        item.course_type_name = enums.CoursePeriodsType.getValue(item.course_type);
        this.handleSendViewTrack(item);
      });
      this.interactive_course_periods = interactive_course_periods;
      this.system_course_periods = system_course_periods;
    },
    isLive(courseType) {
      return (
        courseType === this.PeriodTypeEnum.BIG_CLASS ||
        courseType === this.PeriodTypeEnum.SMALL_CLASS ||
        courseType === this.PeriodTypeEnum.PUBLIC_CLASS ||
        courseType === this.PeriodTypeEnum.OTO_CLASS ||
        courseType === this.PeriodTypeEnum.GROUP_CLASS ||
        courseType === this.PeriodTypeEnum.MULTIPLE_CLASS
      );
    },
    isFace(courseType) {
      return this.PeriodTypeEnum.FACE_CLASS === courseType;
    },
    getPlayTypeTitle(courseType, playType) {
      if (this.isLive(courseType)) {
        if (playType === 1) {
          return '未开始';
        } else if (playType === 2) {
          return '直播中';
        } else if (playType === 3 || playType === 5) {
          return '已结束';
        } else if (playType === 4) {
          return '回放';
        } else if (this.isFace(courseType)) {
          if (playType === 1) {
            return '未开始';
          } else if (playType === 2) {
            return '开课中';
          } else if (playType === 3 || playType === 5) {
            return '已结束';
          } else if (playType === 4) {
            return '已结束';
          }
        } else {
          return '';
        }
      }
    },
    handleSendViewTrack(item) {
      this.$webSeeSendTrack({
        event_id: 'my_study_calendar_course_item_show',
        data: {
          cousrse_info: {
            course_id: item.course_basis_id,
            title: item.course_title,
            course_type: item.course_type,
          },
          section_info: {
            section_id: item.course_chapter_id,
            section_status: this.getPlayTypeTitle(item.course_type, item.live_status),
          },
          live_info: {
            platform: 'pc',
            roomId: item.room_video_id,
          },
          others: {
            from: 'study_calendar',
          },
        },
      });
    },
    onChangeDate(date) {
      this.getStudySchedule(date);
      this.interactive_course_periods = [];
      this.system_course_periods = [];
      this.activeName = '0';
    },
    async onClickDay(date) {
      this.activeName = '0';
      this.$webSeeSendTrack({
        event_id: 'my_course_study_calendar_click',
        event_type: 'click',
      });
      this.time = parseInt(new Date(date).getTime() / 1000);
      await this.getData();
    },
    async goToPlay(item, type) {
      if (item.interception_info) {
        this.currentItem = item;
        this.showContactTeacherDialog = true;
        return;
      }
      if (item.status == 2 && item.is_go_to_study == 0) {
        this.showSoldOut = true;
        return;
      }
      if (item.course_type == 16) {
        if (!type) {
          type = 2;
        }
      } else if (!type) {
        type = 1;
      }
      if (type == 1 && (item.live_status == 2 || item.live_status == 4)) {
        return;
      }
      if (type == 2 && (item.min_live_status == 2 || item.min_live_status == 4)) {
        return;
      }
      if (item.valid_status != 1) {
        return this.$info('该课程已过期，无法继续学习');
      }
      if (item.course_type != 1) {
        await this.$services.CourseService.checkLimit(item.course_basis_id, item.course_chapter_id);
      }
      this.$livePlay(item.course_basis_id, item.course_type, {
        id: item.course_chapter_id,
        title: item.title,
        type: type,
        period_id: item.periods_id,
      });
    },
    async onPeriodClick(item, button) {
      this.currentArrangeItem = item;
      await this.$nextTick();
      if (button.id == 'play') {
        this.$refs.arrange.onPlay();
      } else if (button.id == 'notes') {
        this.$refs.arrange.onDownload(item);
      } else if (button.id == 'leave') {
        this.$refs.arrange.onLeave();
      } else if (button.id == 'tremark') {
        this.$refs.arrange.onTeacherComment();
      } else if (button.id == 'sremark') {
        this.$refs.arrange.onComment();
      }
      this.hideAll();
    },
    hideAll() {
      this.interactive_course_periods.forEach((item) => {
        item.showMore = false;
      });
      this.system_course_periods.forEach((item) => {
        item.showMore = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.courseTab {
  ::v-deep {
    .el-tabs__header {
      padding: 13px 32px 13px 8px;
      border-radius: 8px;
      background: #fff;
      margin-bottom: 24px;
      .el-tabs__nav-wrap {
        &::after {
          display: none;
        }
        .el-tabs__active-bar {
          display: none;
          border-radius: 20px;
          background: #f55;
        }
        .el-tabs__item {
          position: relative;
          height: 30px;
          margin: 0 16px;
          padding: 0 8px;
          line-height: 30px;
          color: #706e79;
          font-size: 16px;
          &.is-active {
            color: #000 !important;
            font-weight: 500;
            &::after {
              content: '';
              position: absolute;
              display: inline-block;
              bottom: 0;
              height: 2px;
              width: 24px !important;
              border-radius: 20px;
              background: #f55;
              left: 50% !important;
              transform: translateX(-50%) !important;
            }
          }
        }
      }
    }
  }
}
</style>
